import { render, staticRenderFns } from "./EditAnchorAccessPoints.vue?vue&type=template&id=30884e23&scoped=true"
import script from "./EditAnchorAccessPoints.vue?vue&type=script&lang=js"
export * from "./EditAnchorAccessPoints.vue?vue&type=script&lang=js"
import style0 from "./EditAnchorAccessPoints.vue?vue&type=style&index=0&id=30884e23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30884e23",
  null
  
)

export default component.exports